import logger from '@/logger';

import getNamespacedName from './getNamespacedName';

const namespacedLog = (namespace, type, name, message, error) => {
  logger.error(`${type} ${getNamespacedName(namespace, name)}: ${message}`, error);
};

export default namespacedLog;



// WEBPACK FOOTER //
// ./src/store/utils/namespacedLog.js